import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-agb',
    templateUrl: './agb.component.html',
    styleUrls: ['./agb.component.scss'],
    standalone: false
})
export class DialogAgb {
    openPrivacy: any;
    constructor(
        public dialogRef: MatDialogRef<DialogAgb>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {
        this.openPrivacy = this.data['openPrivacy'];
    }

    showPrivacy() {
        this.openPrivacy();
    }
}
